import { render, staticRenderFns } from "./actionLog.vue?vue&type=template&id=70023868&"
import script from "./actionLog.vue?vue&type=script&lang=js&"
export * from "./actionLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports